// extracted by mini-css-extract-plugin
export default {"limitedLinesContainer":"styles_limitedLinesContainer__i2VEW","tooltipContainer":"styles_tooltipContainer__II6DC"};